export default __webpack_public_path__ + "static/cookie-e65485f82facc3f9b5030d79708c792b.png";